// extracted by mini-css-extract-plugin
export var dropdown = "_ud-0";
export var imageWrapper = "_ud-3";
export var itemNameContainer = "_ud-1";
export var productImage = "_ud-2";
export var spinnerWrapper = "_ud-4";